export default __webpack_public_path__ + "static/media/slider_bg.ab2c82be.png";